/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DatasetPayload } from './DatasetPayload';
/**
 * Payload structure for dataset webhook notifications.
 *
 * This interface defines the data structure used internally for webhook
 * notifications when dataset exports complete.
 */
export type QueuedDatasetWebhookPayload = {
    /**
     * Unique identifier for tracking this specific export request
     */
    queryUUID: string;
    /**
     * The dataset query configuration submitted by the user
     */
    payload: DatasetPayload;
    /**
     * The webhook URL where results will be sent
     */
    webhookURL: string;
    /**
     * User-provided name for the export
     */
    name: string;
    /**
     * Requested output format
     */
    format: QueuedDatasetWebhookPayload.format;
    /**
     * ID of the user who requested the export
     */
    userId: string;
    /**
     * API key used to authenticate the webhook request and sign the results
     */
    apiKey: string;
    /**
     * Timestamp when the export was originally requested
     */
    requestedOn: string;
};
export namespace QueuedDatasetWebhookPayload {
    /**
     * Requested output format
     */
    export enum format {
        CSV = 'csv',
        JSONL = 'jsonl',
    }
}

